import { calculateTotal, calculateTotalEffluences, calculateTotalOther, calculateTotalPhysique, updateConfigurationWithNewTotal } from "./capsule_configuration.utils";

export const formatDate = (isoDate, withTime = true) => {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${withTime ? `${hours}h${minutes}` : ''}`;
}


export const formatDateForLabelPDF = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(2);

    return `${day}/${month}/${year}`;
}

export const formatDilution = (dilutions) => {
    const dilutionsPriority = {
        A: 1,
        R: 2,
        S: 3,
        E: 4,
        T08E: 5,
        T10E: 6,
        T12E: 7,
    }
    // Convertissez la chaîne de caractères en un tableau en utilisant la virgule comme délimiteur
    const stringArray = dilutions.split(', ');
    // Utilisez un Set pour éliminer les doublons
    const uniqueArray = Array.from(new Set(stringArray))

    // Reconstruisez la chaîne de caractères en utilisant la virgule comme séparateur
    const uniqueString = uniqueArray.sort((a, b) => dilutionsPriority[a] - dilutionsPriority[b]).join('.');
    return uniqueString;
}



export const normalizeString = (string) => {
    return string.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
}

export const formatMixtureRef = (ref) => {
    if (!isNaN(ref) && Number(ref) < 10 && !String(ref).startsWith('0')) return `0${ref}`;
    return ref;
}

export const formatMixtureForConfiguration = (mixture, capsuleName) => {
    delete mixture.dilutionId
    delete mixture.creator
    return {
        mixture,
        dilution: null,
        sensibility: null,
        capsule: mixture.capsule ? mixture.capsule : { id: 0, name: capsuleName },
    }
}

export const mergeMixturesArray = (array1, array2) => {
    if (!array1) return array2;
    if (!array2) return array1;
    const map = new Map();
    [...array1, ...array2].forEach(item => {
        map.set(item.mixture.id, item);
    });

    return Array.from(map.values());
}

export const formatConfigurationForSelection = (content) => {
    if (!content) return {};
    if (content.length === 0) return {};
    const selections = {}
    content.map((item) => {
        selections[item.mixture.id] = true
    })
    return selections
}

export const formatCapsuleConfigurationForDatabase = (configuration, capsuleId) => {
    configuration.content.map((item) => {
        delete item.capsule
        return item
    })

    const configWithTotals = updateConfigurationWithNewTotal(configuration)

    return {
        capsuleId: capsuleId,
        configuration: configWithTotals
    }

}

export const divideConfigurationByCapsule = (configuration, defaultCapsuleId) => {
    // Find capsule in configuration.content
    // Divide configuration.content by capsule


    const capsules = configuration.content.reduce((acc, item) => {
        if (acc.includes(item.capsule.id)) return acc
        return [...acc, item.capsule.id]
    }, [])

    const capsuleConfigurations = capsules.map((capsuleId) => {
        const content = configuration.content.filter((item) => item.capsule.id === parseInt(capsuleId))
        if (capsuleId === 0) {
            return {
                content,
                emotionalDisturbance: configuration.emotionalDisturbance,
                emotionalInversion: configuration.emotionalInversion,
                mentalDisturbance: configuration.mentalDisturbance,
                organicInversion: configuration.organicInversion,
                maintainSymptoms: configuration.maintainSymptoms,
                total: calculateTotal(content),
                totalPhysique: calculateTotalPhysique(content),
                totalEffluence: calculateTotalEffluences(content),
                totalOther: calculateTotalOther(content),
                capsuleId: defaultCapsuleId,

            }
        } else {
            return {
                content,
                emotionalDisturbance: null,
                emotionalInversion: null,
                mentalDisturbance: null,
                organicInversion: null,
                maintainSymptoms: null,
                total: calculateTotal(content),
                totalPhysique: calculateTotalPhysique(content),
                totalEffluence: calculateTotalEffluences(content),
                totalOther: calculateTotalOther(content),
                capsuleId: null


            }
        }
    })
    return capsuleConfigurations
}

export const cleanProductDescription = (description) => {
    if (!description) return ""; // Si la description est nulle ou indéfinie, retourner une chaîne vide

    // Créer un élément temporaire pour analyser le HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = description;

    // Supprimer les balises vides
    const paragraphs = tempDiv.getElementsByTagName("p");
    for (let i = paragraphs.length - 1; i >= 0; i--) {
        if (paragraphs[i].innerHTML.trim() === "" || paragraphs[i].innerHTML.trim() === "&nbsp;") {
            paragraphs[i].remove();
        }
    }

    // Vérifier si le contenu est vide après nettoyage
    return tempDiv.innerHTML.trim() === "" ? "" : tempDiv.innerHTML; // Retourner le HTML nettoyé ou une chaîne vide
};
